import { Logger, LogTag, ServiceType } from "@lib/monitoring/logger";
import { FetchServiceAxios } from "@lib/helpers/fetchServiceAxios";
import apiMiddleware from "@lib/utils/api/apiMiddleware";
import { GOOGLE_PROJECT_NAME } from "@lib/constants/addresses";

export const RECAPTCHA_TRESHOLD = 0.7;

const handler = async (req, res) => {
    if (req.method === "POST") {
        try {
            const recaptchaResponse: { riskAnalysis: { score: number } } =
                await FetchServiceAxios.post(
                    `https://recaptchaenterprise.googleapis.com/v1/projects/${GOOGLE_PROJECT_NAME}/assessments?key=${process.env.GOOGLE_RECAPTCHA_API_KEY}`,
                    {
                        event: {
                            token: req.body.recaptchaToken,
                            siteKey: process.env.NEXT_PUBLIC_RECAPTCHA_TOKEN,
                        },
                    }
                );

            if (recaptchaResponse?.riskAnalysis.score < RECAPTCHA_TRESHOLD) {
                Logger.error(
                    ServiceType.GOOGLE,
                    `ReCaptcha riskAnalysis score is less than treshold ${RECAPTCHA_TRESHOLD}`,
                    {
                        tag: LogTag.RECAPTCHA,
                        recaptchaResponse,
                    }
                );
                res.status(403).json({ message: "ReCaptcha check is failed" });
                return;
            }

            res.status(200).json(recaptchaResponse);
        } catch (error) {
            Logger.error(ServiceType.GOOGLE, `ReCaptcha check is failed`, {
                tag: LogTag.RECAPTCHA,
                error: {
                    name: error?.name,
                    message: error?.message,
                    stack: error?.stack,
                    ...error,
                },
            });
            res.status(400).json(error);
        }
    } else {
        res.status(405).json({
            error: {
                message: "This endpoint only takes Post requests",
            },
        });
    }
};

export default apiMiddleware(handler);
